import { IDocument } from '../infrastructure/interfaces';
import { ActionType } from '../infrastructure/actionTypes';

export default (list: Array<IDocument>, action: any) => {
  switch (action.type) {
    case ActionType.GET_DOCUMENT_LIST_DONE:
      return [...action.documentList];
    case ActionType.DELETE_DOCUMENT:
      return list.filter(d => d.id !== action.id);
    case ActionType.CLONE_DOCUMENT:
      return [...list, action.newDocument]
    default:
    {
      if (list == undefined) {
        return [];
      }
      return list;
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/documentList.ts